import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const VIDEO_CALL_INFO_SIDE_LIST = 'videoCallInfo';

/**
 * The exercise library's folder/template side list. Its key used to fall back to
 * the German title, so the literal has to stay `Vorlagen` — it is what users
 * already have persisted in localStorage.
 */
export const EXERCISE_LIBRARY_SIDE_LIST = 'Vorlagen';

/**
 * The main navigation sidebar. Not a `GenericSideList`, but it collapses to an
 * icon rail with the same persisted-per-key semantics, so it reuses this store.
 */
export const MAIN_NAV_SIDE_LIST = 'mainNav';

const storageKey = (key: string) => `sideList_${key}_collapsed`;

export const useSideListStore = defineStore('sideList', () => {
  const collapsed = reactive<Record<string, boolean>>({});

  function register(key: string, defaultCollapsed = false) {
    if (key in collapsed) return;
    const saved = localStorage.getItem(storageKey(key));
    collapsed[key] = saved === null ? defaultCollapsed : saved === 'true';
  }

  function isCollapsed(key: string): boolean {
    return collapsed[key] ?? false;
  }

  function setCollapsed(key: string, value: boolean) {
    collapsed[key] = value;
    localStorage.setItem(storageKey(key), String(value));
  }

  function toggle(key: string) {
    setCollapsed(key, !isCollapsed(key));
  }

  return { collapsed, register, isCollapsed, setCollapsed, toggle };
});
